export default "__VITE_ASSET__517fc30b__"